module.exports = __webpack_public_path__ + "img/tic-tac-two.a502b5c9.svg";